import { useTenant } from './useTenant';

export function usePermissions() {
  const { can, permissions, role } = useTenant();
  return { can, permissions, role };
}
